import Vue from 'vue';
// import _ from 'underscore';
import api from '@/api/index';
import * as filters from '@/utils/filter';
// import mixins from './mixins.js'
/**
 * 把一些全局对象和一些全局方法，注册到Vue原型上
 */
Vue.use({
  install(Vue, options) {
    Vue.prototype.$api = api;
  },
});

// 实例化Vue的filter
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));
